import { ExperiencesRequest, ExperiencesResponse, IAddressResponse } from '@cemex-core/cmx-api';
import { IJobsiteBlockedRequest } from '@cemex-core/cmx-api/models/jobsite-blocked';
import { Action } from '@ngrx/store';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { IJobsiteSalesAreaResponse } from '../../models/order-management/jobsite-sales-area.model';
import { IRequestJobsitesResponse, Jobsite } from '../../models/order-management/jobsite.model';

export interface IGeoCoordinates {
  latitude: number;
  longitude: number;
}

export const LS_LOAD_INITIAL_STATE = '[bulkCement - Jobsite] Load initial state';
export const LS_RESET = '[bulkCement - Jobsite] Reset state';
export const LS_LOAD = '[bulkCement - Jobsite] Load';
export const LS_LOAD_COMPLETE = '[bulkCement - Jobsite] Load Complete';
export const LS_LOAD_FAIL = '[bulkCement - Jobsite] Load Fail';
export const LS_JOBSITE_SET = '[bulkCement - Jobsite] Set';
export const LS_SALES_AREA_LOAD = '[bulkCement - salesAreas] Load';
export const LS_SALES_AREA_LOAD_COMPLETE = '[bulkCement - salesAreas] Load Complete';
export const LS_LOAD_ADDRESS = '[LocationSpecification - Address] Load Address';
export const LS_LOAD_ADDRESS_SUCCESS = '[LocationSpecification - Address] Load success Address';
export const LS_LOAD_ADDRESS_FAIL = '[LocationSpecification - Address] Load fail Address';
export const LS_JOBSITE_MODAL = '[LocationSpecification - Jobsite] Open jobsite change modal';
export const LS_LOAD_EXPERIENCE = '[LocationSpecification - Experience] Load Experience';
export const LS_LOAD_EXPERIENCE_SUCCESS = '[LocationSpecification - Experience] Load success Experience';
export const LS_LOAD_EXPERIENCES_FAIL = '[LocationSpecification - Experience] Load fail Experience';
export const LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_SUCCESS =
  '[LocationSpecification - PurchaseOrder] Load success Purchase Order Mask Patterns';

export class LoadJobsiteExperience {
  readonly type = LS_LOAD_EXPERIENCE;
  constructor(public payload: { experiencesRequest: ExperiencesRequest; salesDocumentTypeId: number }) {}
}

export class LoadJobsiteExperienceComplete {
  readonly type = LS_LOAD_EXPERIENCE_SUCCESS;

  constructor(public payload: { experiencesResponse: ExperiencesResponse; salesDocumentTypeId: number }) {}
}

export class LoadJobsiteExperienceFail {
  readonly type = LS_LOAD_EXPERIENCES_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class LoadJobsiteAddress {
  readonly type = LS_LOAD_ADDRESS;
  constructor(public payload: number) {}
}

export class LoadJobsiteAddressComplete {
  readonly type = LS_LOAD_ADDRESS_SUCCESS;

  constructor(public payload: IAddressResponse) {}
}

export class LoadJobsiteAddressFail {
  readonly type = LS_LOAD_ADDRESS_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class JobsiteLoadInitialStateAction implements Action {
  readonly type = LS_LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class JobsiteResetStateAction implements Action {
  readonly type = LS_RESET;

  constructor(public payload = null) {}
}

export class JobsiteLoadAction implements Action {
  readonly type = LS_LOAD;

  constructor(public payload: IJobsiteBlockedRequest) {}
}

export class JobsiteLoadCompleteAction implements Action {
  readonly type = LS_LOAD_COMPLETE;

  constructor(public payload: IRequestJobsitesResponse) {}
}

export class JobsiteLoadFailAction implements Action {
  readonly type = LS_LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class JobsiteSetAction implements Action {
  readonly type = LS_JOBSITE_SET;

  constructor(public payload: Jobsite) {}
}

export class SalesAreaLoadAction implements Action {
  readonly type = LS_SALES_AREA_LOAD;

  constructor(
    public payload: {
      productlineId: number | string;
      shipmentlocationId: number | string;
      shippingConditionId: number | string;
    },
  ) {}
}

export class SalesAreaLoadCompleteAction implements Action {
  readonly type = LS_SALES_AREA_LOAD_COMPLETE;

  constructor(
    public payload: {
      salesAreas: IJobsiteSalesAreaResponse;
      productlineId: number | string;
      shipmentlocationId: number | string;
      shippingConditionId: number | string;
    },
  ) {}
}

export class JobsiteOpenModalAction implements Action {
  readonly type = LS_JOBSITE_MODAL;
  constructor(public payload: { openModal: boolean }) {}
}

export class PurchaseOrderMaskPatterLoadCompleteAction implements Action {
  readonly type = LS_LOAD_PURCHASE_ORDER_MASK_PATTERNS_SUCCESS;
  constructor(public payload: { purchaseOrderMaskPatterns: string[] }) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type JobsiteActions =
  | JobsiteLoadAction
  | JobsiteLoadInitialStateAction
  | JobsiteResetStateAction
  | JobsiteLoadFailAction
  | JobsiteLoadCompleteAction
  | JobsiteSetAction
  | SalesAreaLoadCompleteAction
  | SalesAreaLoadAction
  | LoadJobsiteAddress
  | LoadJobsiteAddressComplete
  | LoadJobsiteAddressFail
  | JobsiteOpenModalAction
  | LoadJobsiteExperience
  | LoadJobsiteExperienceComplete
  | PurchaseOrderMaskPatterLoadCompleteAction;
